import React from "react"

const Dialpad = ({ bgUrl, name, textColor, menuColor, menuItems, font }) => {
  const menuItem = menuItems.slice(0, 9).map(item => (
    <div
      style={{
        fontSize: "0.7em",
        padding: "5px",
        width: "60px",
        height: "60px",
        margin: "3px",
        borderRadius: "15%",
        textAlign: "-webkit-center",
        backgroundColor: menuColor,
      }}
      key={item?.id}
    >
      <span
        style={{
          color: textColor,
          fontFamily: font,
          fontWeight: "bold",
        }}
      >
        {item?.label}
      </span>
      <div
        style={{
          backgroundImage: `url("${item?.icon?.url}")`,
          width: "18px",
          height: "18px",
          backgroundSize: "cover",
        }}
      />
    </div>
  ))

  return (
    <div
      style={{
        backgroundImage: bgUrl,
        width: "105%",
        height: "105%",
        backgroundSize: "cover",
        marginLeft: "-5px",
        backgroundPosition: "center center",
        boxShadow: "inset 0 0 0 500px rgb(0 0 0 / 40%)",
      }}
    >
      <p
        style={{
          fontSize: "25px",
          textAlign: "center",
          paddingBlockStart: "2.2em",
          color: "white",
        }}
      >
        {name}
      </p>
      <div
        style={{
          paddingTop: "10px",
          flexWrap: "wrap",
          flexDirection: "row",
          justifyContent: "center",
          display: "flex",
        }}
      >
        {menuItem}
      </div>
    </div>
  )
}

export default Dialpad
